import React from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

//STYLES
import * as OrderConfirmationStyles from "../../styles/checkout/processOrder";

function OrderConfirmation() {
    const navigate = useNavigate();

    function handleGoBack() {
        navigate("../");
    }

    return (
        <div style={OrderConfirmationStyles.body}>
            <h1>Order Confirmation</h1>
            <p>Thank you for your order</p>
            <br />
            <Button onClick={handleGoBack}>Continue Shopping</Button>
        </div>
    );
}

export default OrderConfirmation;
